import { cn } from '@/lib/utils';
import { formatName } from '@/lib/name';

interface MemberDisplayProps {
  member: {
    id: string;
    name: string;
    initials?: string;
    avatarUrl?: string;
    avatar?: string; // Support both naming conventions from different parts of the app
  };
  size?: 'sm' | 'md' | 'lg'; // Different size options
  variant?: 'badge' | 'list' | 'simple'; // Different display variants
  className?: string;
  avatarClassName?: string;
  textClassName?: string;
}

export function MemberDisplay({
  member,
  size = 'md',
  variant = 'simple',
  className,
  textClassName,
}: MemberDisplayProps) {
  // Size maps
  const sizeClasses = {
    sm: {
      container: 'gap-1',
      text: 'text-xs',
    },
    md: {
      container: 'gap-2',
      text: 'text-sm',
    },
    lg: {
      container: 'gap-3',
      text: 'text-base',
    },
  };

  // Variant maps
  const variantClasses = {
    badge: 'py-1 px-2 rounded-full bg-accent/10 border border-accent/20',
    list: 'rounded-md bg-accent/10',
    simple: '',
  };

  return (
    <div
      className={cn(
        'flex items-center',
        sizeClasses[size].container,
        variantClasses[variant],
        className
      )}
    >
      <span
        className={cn(sizeClasses[size].text, 'font-medium', textClassName)}
      >
        {formatName(member.name)}
      </span>
    </div>
  );
}
